<div 
    class="progress"
    [class.progress--small]="size === 'small'"
    [class.progress--medium]="size === 'medium'"
    [class.progress--large]="size === 'large'"
    data-test="progress">

    <!-- bg ring -->
    <svg
        class="progress__ring-bg"
        [attr.width]="diameter"
        [attr.height]="diameter">
        <circle
            class="progress__circle"
            stroke="#F9FAFD"
            [attr.stroke-width]="strokeWidth"
            fill="transparent"
            [attr.r]="(diameter/2) - (strokeWidth*2)"
            [attr.cx]="diameter/2"
            [attr.cy]="diameter/2"/>
    </svg>

    <!-- progress ring -->
    <svg
        class="progress__ring"
        [attr.width]="diameter"
        [attr.height]="diameter">
        <circle
            #progressCircle
            class="progress__circle"
            stroke="#5BB96F"
            [attr.stroke-width]="strokeWidth"
            fill="transparent"
            [attr.r]="(diameter/2) - (strokeWidth*2)"
            [attr.cx]="diameter/2"
            [attr.cy]="diameter/2"/>
    </svg>

    <!-- percentage -->
    <div class="progress__label text-semibold" data-test="progressPercentage">
        {{ progress }}%
    </div>

</div>